// extracted by mini-css-extract-plugin
module.exports = {"barcodeScanner":"BarcodeScanner_barcodeScanner__EoCjI","video":"BarcodeScanner_video__icemU"};